import {$} from './jquery-definition.js';
import 'is-in-viewport';
import './libraries/jquery.cycle2';

$( function() {
	animateInViewport();

	var $backgroundSlider = $( '.background-slider' );
	if ( $backgroundSlider.length ) {
		$backgroundSlider.cycle( {
			'slides': '> div',
			'timeout': 8000,
			'speed': 1000
		} );
	}
} );

$( window ).scroll( function() {
	setTimeout( function() {
		animateInViewport();
	}, 100 );
} );

export function animateInViewport() {
	$( '.move-up-in-viewport, .move-down-in-viewport, .fade-in-in-viewport, .zoom-in-in-viewport' ).each( function() {
		var $this = $( this );

		if ( $this.is( ':in-viewport' ) ) {
			$this.addClass( 'active' );
		}
	} );
}
